<template>
  <div class="checkout-builder-draggable-elements">
    <h5 class="mb-5 text-dark-40">
      Arraste e solte os elementos nas áreas desejadas
    </h5>

    <div class="elements-container">
      <draggable
        v-for="element in elements"
        handle=".handle"
        :key="element.type"
        :group="{ name: 'components', put: false, pull: 'clone' }"
        @end="onDragEnd"
        @start="() => onDragStart(element)"
      >
        <div class="draggable-element handle">
          <div class="d-flex" v-if="Array.isArray(element.icon)">
            <i
              v-for="icon in element.icon"
              size="24"
              :key="icon"
              :class="icon"
            />
          </div>
          <i v-else size="24" :class="element.icon" />
          <div class="fs-14">{{ element.label }}</div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import elements from "./elements";

export default {
  components: { draggable },
  data() {
    return {
      elements
    };
  },
  methods: {
    onDragStart(element) {
      this.$store.commit("checkoutBuilder/setElement", element.type);
    },
    onDragEnd() {
      this.$store.commit("checkoutBuilder/setElement", null);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-draggable-elements {
  padding: 0px 16px;
  .elements-container {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
    gap: 16px;
    .draggable-element {
      gap: 12px;
      padding: 12px;
      display: flex;
      user-select: none;
      border-radius: 12px;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border: 1px dashed var(--blue-secondary);
      cursor: grab;

      transition: 0.2s all;
    }
  }
}
</style>
